export enum OrderDeliveryMethodEnum {
  Fax = 1,
  Digital = 2,
  Courier = 3
}

export const OrderDeliveryMethodOptions = [
{ id: 1, label: 'Fax' },
{ id: 2, label: 'Digital' },
{ id: 3, label: 'Courier' }
];
